<template>
    <div class="account">
        <div class="msgring flexbox fle-sb">
            <div class="fnts" v-if="unread>0">
              <el-badge is-dot class="item">
                <i class="el-icon-message-solid colorb"></i>
              </el-badge>
                <div>{{$t('account.message')}}</div>
            </div>
            <div class="fnts" v-else>
              <i class="el-icon-message-solid colorb"></i>
              <div>{{$t('account.message')}}</div>
            </div>
            <div class="flex2 fontw">{{message}}</div>
            <div class="btnn" @click="jumpmsg">
                {{$t('account.more_message')}}<i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="contbox">
            <div>
                <div class="level flexbox  fle-sb">
                    <img src="../assets/imgs/logo.png">
                    <div class="flex2 flexbox texal padl linbor">
                      <div>
                        <div class="minw">{{$t('account.hello')}} {{user.username ? user.username : $t('account.visitor')}}</div>
                        <div v-if="user.grade_id > 0">
                            <span class="active">vip</span>
                            <span class="colory">VIP{{user.grade_id}}</span>
                        </div>
                      </div>
                      <div class=" padl  fle-wrap">
                        <div class="item6">{{$t('account.daily_money_left')}} <span class="colory">{{user.daily_money}}USDT</span></div>
                        <div class="item6">{{$t('account.month_money_left')}} <span class="colory">{{user.month_money}}USDT</span></div>
                        <div class="item6" v-if="user.grade_id > 0">{{$t('account.time_remaining2')}} <span class="colory">{{countDownTime}}</span></div>
<!--                        <div class=" item5">会员剩余:29天 10:30:39</div>-->
                      </div>
                    </div>
                    <div class="btnn bgb" @click="jumplevelup">{{$t('account.vip_up_level')}}</div>
                </div>
                <div class="flexbox fle-sb wi10">
                    <div class="bgbl flexbox fle-sb wdzc">
                        <img src="../assets/imgs/qd.png">
                        <div class="texal flex2 padl">
                            <div class="colory fontw">{{user.money}}USDT<span class="minim2"> ≈ ${{user.money}}</span></div>
                            <div>{{$t('account.balance')}}</div>
                        </div>
                    </div>
                    <div class="bgbl mnbox">
                        <div class="flexbox  fle-sa">
                            <div class="btnn" @click="jumpinvestMoney"><i class="el-icon-s-finance"></i>{{$t('account.recharge')}}
                            </div>
                            <div class="borderl btnn" @click="jumpcash"><i class="el-icon-coin"></i>{{$t('account.withdrawal')}}
                            </div>
                            <div class="borderl btnn" @click="jumptransfer"><i class="el-icon-money"></i>{{$t('account.transfer')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tiptit"><i class="el-icon-s-help colorb"></i>{{$t('account.services')}}</div>
                <div class="flexbox fle-sb acbot">
                    <div class="blbtm">
                        <div class="borderwhite">
                            <i class="el-icon-s-finance"></i>
                        </div>
                        <div class="btnbox">
                            <div class="btnn bgb borderr" @click="jumpMngmny">{{$t('account.financing')}}</div>
                        </div>
                    </div>
                    <div class="blbtm">
                        <div class="borderwhite">
                            <i class="el-icon-wallet"></i>
                        </div>
                        <div class="btnbox">
                            <div class="btnn bgb borderr" @click="jumpMoneyBags">{{$t('account.wallet')}}</div>
                        </div>
                    </div>
                    <div class="blbtm">
                        <div class="borderwhite">
                            <i class="el-icon-user-solid"></i>
                        </div>
                        <div class="btnbox">
                            <div class="btnn bgb borderr" @click="jumpacSave">{{$t('account.security')}}</div>
                        </div>
                    </div>
                    <div class="blbtm">
                        <div class="borderwhite">
                            <i class="el-icon-question"></i>
                        </div>
                        <div class="btnbox">
                            <div class="btnn bgb borderr" @click="jumpQuestion">{{$t('account.question')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getInfo} from '@/api/account'

    export default {
        name: 'accountView',
        data() {
            return {
                user: {
                    user_id: 0,
                    username: '',
                    money: '0.00',
                    grade_id: 0,
                },
                leftVipTime: '',
                countDownTime: '',
                countDownFn: null,
                email: '',
                message: '',
                lang: 'zh',
                unread: 0
            }
        },
        created() {
            if (this.isApp()) {
                this.$router.replace('/home/accountApp')
            } else {
                this.getData()
            }
        },
        destroyed(){
            clearInterval(this.countDownFn); //清除定时器
        },
        methods: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            getData() {
                getInfo().then(res => {
                    const data = res.data
                    this.user = data.user
                    this.email = data.email
                    this.message = data.message
                    this.unread = data.unread
                    this.leftVipTime = res.data.leftVipTime
                    if(this.leftVipTime){
                        this.countDown()
                    }

                }).catch(_ => {

                })
            },
            countDownFun(time) {
                // console.log(time)
                let startTime = new Date(); //当前时间
                let end = new Date(time); //结束时间
                // console.log(end)
                let result = parseInt((end - startTime) / 1000); //计算出豪秒
                let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
                let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
                let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
                let s = parseInt(result % 60);
                //当倒计时结束时，改变内容
                if (result <= 0) {
                    return 0
                }
                if (h < 10) {
                    h = "0" + h
                }
                if (m < 10) {
                    m = "0" + m
                }
                if (s < 10) {
                    s = "0" + s
                }
                if (h == 0 && m == 0) {
                    return s + "s"
                } else if (h == 0) {
                    return m + ":" + s
                } else if (d == 0) {
                    return h + ":" + m + ":" + s
                } else {
                    if(d > 1){
                        return d + this.$t('account.days') + h + ":" + m + ":" + s
                    }else{
                        return d + this.$t('account.day') + h + ":" + m + ":" + s
                    }
                }
            },
            // 定时器
            countDown() {
                let that = this;
                that.countDownFn = setInterval(() => {
                    //  console.log(that.countDownFun(item.leftVipTime))
                    let html = that.countDownFun(that.countDownTime)
                    if (html === 0) {
                        that.leftVipTime = ''
                        clearInterval(that.countDownFn); //清除定时器
                        that.getData()
                    } else {
                        that.countDownTime = that.countDownFun(that.leftVipTime)
                    }
                }, 1000)
            },
            changlang(lang, item) {
                if (lang != this.lang) {
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            jumpmsg() {
                this.$router.push({path: '/home/msglist'})
            },
            jumplevelup() {
                this.$router.push({path: '/home/levelup'})
            },
            jumpMngmny() {
                this.$router.push({path: '/home/myMoneyManage'})
            },
            jumpacSave() {
                this.$router.push({path: '/home/acSave'})
            },
            jumpMoneyBags() {
                this.$router.push({path: '/home/moneyBag'})
            },
            jumpinvestMoney() {
                this.$router.push({path: '/home/investMoney'})
            },
            jumpcash() {
                this.$router.push({path: '/home/cash'})
            },
            jumptransfer() {
                this.$router.push({path: '/home/transfer'})
            },
            jumpQuestion() {
                this.$router.push({path: '/home/questions'})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .account {
        width: 1200px;
        margin: 30px auto;
        color: #fff;
        font-size: 20px;

        .msgring {
            background: #272727;
            border-radius: 10px;
            padding: 30px 20px;
            box-sizing: border-box;

            & > div {
                padding: 0px 30px;
                box-sizing: border-box;

                &.fontw {
                    text-align: left;
                    font-weight: bold;
                }

                &.fnts {
                    font-size: 26px;
                }
            }
        }
        .tex2en{
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2; // 2行
        }
        .minw{
          min-width: 200px;
        }
        .item5{
          width: 40%;
        }
        .contbox {
            margin: 30px 0px;
            padding: 20px 40px 80px 40px;
            box-sizing: border-box;
            border-radius: 10px;
            background: #272727;

            .level {
                line-height: 30px;
                padding: 20px 0px;
                margin-bottom: 30px;

                img {
                    width: 100px;
                    height: 100px;
                    border-radius: 100%;
                }

                .linbor {
                    line-height: 40px;
                }
            }

            span.active {
                color: #1750cc;
                padding: 2px 0px;
                margin-right: 10px;
                border-top: 2px solid #1750cc;
                border-bottom: 2px solid #1750cc;
            }

            .bgb {
                padding: 10px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }

            .bgbl {
                background: #1a1a1a;
                border-radius: 10px;
                padding: 30px 40px;
                height: 160px;
                box-sizing: border-box;
                // width: 40%;
                font-size: 22px;

                &.mnbox {
                    line-height: 90px;
                }

                .borderl {
                    position: relative;

                    &::before {
                        content: '';
                        width: 1px;
                        height: 10px;
                        left: -16px;
                        top: 40px;
                        background: #fff;
                        position: absolute;
                    }
                }
            }

            .wi10 {
                width: 100%;

                .bgbl {
                    width: 45%;
                }

            }

            .wdzc {
                .fontw {
                    line-height: 60px;
                }

                img {
                    width: 80px;
                    height: auto;
                }
            }

            .fontw {
                font-weight: bold;
                font-size: 24px;
            }

            .tiptit {
                text-align: center;
                line-height: 60px;
                margin: 50px auto;
                font-size: 22px;
                font-weight: bold;

                i {
                    font-size: 40px;
                    padding-right: 20px;
                    vertical-align: sub;
                }

                img {
                    width: 40px;
                    height: 40px;
                    vertical-align: middle;
                    padding-right: 20px;
                }
            }

            .acbot {
                .blbtm {
                    border-radius: 10px;
                    background: #1a1a1a;

                    .borderwhite {
                        border: 1px solid #494949;
                        padding: 40px 60px;
                        border-radius: 10px;
                        font-size: 100px;

                        img {
                            width: 100px;
                            height: 100px;
                        }
                    }

                    .btnbox {
                        padding: 20px;
                        box-sizing: border-box;

                        .borderr {
                            border-radius: 6px;
                        }
                    }
                }
            }
        }
    }
</style>
